import { Injectable } from '@angular/core';
import { CategoryOverTimeDTO } from 'src/app/cxone/dashboard/modules/category-over-time/category-over-time.model';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';

@Injectable({
    providedIn: 'root'
})
export class CategoryOverTimeService {
    constructor(private cvApi: CVApiService) { }

    async loadData(moduleKey: string, isAutoRefresh: boolean, isFirstLoad: boolean): Promise<CategoryOverTimeDTO> {
        let renderEndpoint: string;
        try {
            renderEndpoint = await this.cvApi.getModuleRenderEndPoint(moduleKey);
        }
        catch (error) {
            console.error("Failed to get module render endpoint for Cateory Over Time.");
            throw error;
        }
        try {
            const url = `/api/v2/dashboards/modules/categoryovertime/${moduleKey}`;
            const response = await this.cvApi.get<CategoryOverTimeDTO>(url, renderEndpoint);
            if (response.status_code === 200)
                return response.data;
            throw response;
        }
        catch (error) {
            console.error("Failed getting Category Over Time data.");
        }
        return null;
    }

    async exportData(moduleKey: string, format: string) {
        let renderEndpoint;
        try {
            renderEndpoint = await this.cvApi.getModuleRenderEndPoint(moduleKey);
        }
        catch (error) {
            console.error("Failed getting render endpoint.");
            throw error;
        }

        const url = `/api/v2/dashboards/modules/categoryovertime/${moduleKey}/export?format=${format}`;

        try {
            const response = await this.cvApi.get<string>(url, renderEndpoint);
            if (response.status_code !== 200)
                throw response;
            return response;
        }
        catch (error) {
            console.error("Failed getting top categories data for export.");
            throw error;
        }
    }

    async getCXoneTeamNames(moduleKey: string): Promise<any> {
        let renderEndpoint: string;
        try {
            renderEndpoint = await this.cvApi.getModuleRenderEndPoint(moduleKey);
        }
        catch (error) {
            console.error("Failed to get module render endpoint for Cateory Over Time.");
            throw error;
        }
        try {
            const url = `/api/v2/dashboards/modules/cxoneteams/${moduleKey}/search`;
            const response = await this.cvApi.get<any>(url, renderEndpoint);
            if (response.status_code === 200)
                return response.data.teams;
            throw response;
        }
        catch (error) {
            console.error("Failed getting team data.");
        }
        return [];
    }
}
